/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';

export default (router) => {
    router(`/dashboard/tspay`, controller.plan, makeLayout, render);
};
